import { memo } from "react";
import { Text, useTheme, type DivProps, type OmitProps } from "react-better-html";

import { formatPrice } from "../../utils/functions";
import { useI18n } from "../../utils/i18n";

import DecorationCard from "./DecorationCard";

type DecorationTotalTrackedCardProps = OmitProps<DivProps, "children"> & {};

function DecorationTotalTrackedCard({ ...props }: DecorationTotalTrackedCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <DecorationCard whiteSpace="nowrap" {...props}>
         <Text fontSize={12} color={theme.colors.textSecondary}>
            {t((l) => l.components.decorations.totalTracked)}
         </Text>
         <Text fontSize={18} fontWeight={700}>
            {formatPrice(1_680_000, "EUR")}
         </Text>
      </DecorationCard>
   );
}

export default memo(DecorationTotalTrackedCard);
